module.exports = __webpack_public_path__ + "static/img/hxcp.2e40a29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/imgs/hxcp.png
// module id = 1OUD
// module chunks = 0